import React, { useState } from "react";
import { useUserStore } from "(store)/useUserStore";
import * as Components from "components";
import { toast } from "react-toastify";
import { Formik, Form } from "formik";
import SettingProfileForm from "./SettingProfileForm";
import { FormButton } from "components/formfields";
import { profileSettingSchema } from "utils/Validation";
import { getProfile, updateProfile } from "services/admin.service";
import { checkEmail } from "services/auth.service";

const Profile = () => {
  const [error, setError] = useState("");
  const { userInfo, setUser } = useUserStore();
  let stringPhone = userInfo?.phone && userInfo.phone.toString();

  const initialValues = {
    firstName: userInfo?.firstName || "",
    lastName: userInfo?.lastName || "",
    email: userInfo?.email || "",
    userName: userInfo?.userName || "",
    phone: stringPhone || "",
    streetAddress: userInfo?.address?.streetAddress || "",
    city: userInfo?.address?.city || "",
    state: userInfo?.address?.state || "",
    zip: userInfo?.address?.zipCode || "",
    profileImage: userInfo?.profileImg || "",
    // For Profile Image Uploader
  };

  const fetchProfile = () => {
    getProfile()
      .then((res) => {
        if (res?.status === 200) {
          const { data } = res.data;
          if (data) {
            setUser(data);
          }
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setSubmitting(true);

    const formData = new FormData();

    const { profileImage, ...otherValues } = values;

    if (profileImage instanceof File) {
      formData.append("file", profileImage);
      formData.append("data", JSON.stringify(otherValues));
    } else {
      formData.append(
        "data",
        JSON.stringify({ ...otherValues, profileImg: [] })
      );
    }

    try {
      if (values?.email !== userInfo?.email) {
        await checkEmail(values.email);
      }
      await updateProfile(formData);
      toast.success("Profile updated successfully!");
      fetchProfile();
    } catch (error) {
      toast.error(error?.error || "Profile update failed!");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen p-5 border dark:border-gray-800 dark:bg-[#181818] my-5 mx-5 2xl:mx-14 rounded-lg shadow-lg">
      <div className="w-full border-0 border-b dark:border-b-gray-800 py-4">
        <p className="text-xl text-secondary dark:text-alpha">
          Profile Details
        </p>
        <p className="text-md text-[#737373] dark:text-gray-300">
          This is the main profile that will be visible for everyone
        </p>
      </div>
      <div className="flex-1 flex flex-col">
        {" "}
        <Formik
          initialValues={initialValues}
          enableReinitialize={true}
          validationSchema={profileSettingSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting, isValid, values, setFieldError }) => {
            return (
              <Form className="flex-1 flex flex-col justify-between">
                <SettingProfileForm
                  values={values}
                  setFieldError={setFieldError}
                  error={error}
                  setError={setError}
                />
                <div className="w-20 self-end pt-6">
                  <FormButton
                    type="submit"
                    disabled={isSubmitting || !isValid || error}
                    variant="filled"
                    text={isSubmitting ? <Components.Spinner /> : "Save"}
                  />
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default Profile;
